
import { Component, Vue } from "vue-property-decorator";
import { authService } from "@/core/service/licencesnationales/AuthentificationService";
import { Logger } from "@/utils/Logger";

@Component
export default class Footer extends Vue {
  appVersion: string = process.env.VUE_APP_VERSION;
  backVersion: string = "";
  mounted() {
    authService
      .getVersion()
      .then(response => {
        this.backVersion = response.data;
      })
      .catch(error => {
        Logger.error("Impossible de récupérer le numéro de version : " + error);
      });
  }
}
